import { faCheck } from "@fortawesome/free-solid-svg-icons";
import create_pixel from "../../static-assets/events-manager-meta-pixel-creation.gif";
import insight_tag from "../../static-assets/insight-tag.png";
import * as C from "../controls"
import YouTube from 'react-youtube';
import React from "react";
import * as P from "../program-state";
import { issue_json_get, v1api, authn_token } from "../program-state";
import {z} from "zod"
import { useWizardContext } from "./wizard-provider";


export const Asset_instruction_placeholder = () => {
    return (
        <div className="tw-space-y-2 tw-max-w-full tw-overflow-x-auto">
            <C.Eres_headerlg>General Guide (placeholder till we have guide)</C.Eres_headerlg>
            <p className="tw-break-words">Most people don't realize that when you sign up for Facebook, you're automatically creating an ad account also. Just go to Facebook's ads manager and you can note your Ad Account Identification number in the upper left.</p>
            <div className="tw-w-full tw-max-w-2xl">
                <YouTube videoId="o-ACY99hrhc" opts={{width: '100%'}} className="tw-mx-auto"/>
            </div>
            <C.Eres_headerxl>Step 1. Do this</C.Eres_headerxl>
            <p className="tw-break-words">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer tincidunt elementum molestie. Etiam ornare purus nec tincidunt vulputate. Duis sed faucibus quam. Interdum et malesuada fames ac ante ipsum primis in faucibus. In eleifend ipsum vitae bibendum maximus. Phasellus eleifend non leo nec ultricies. Donec venenatis in quam in fermentum. Vestibulum quam lacus, rhoncus vel sapien quis, dignissim eleifend dui. Donec faucibus ante erat, et tristique est faucibus eget.</p>
            <C.Eres_headerxl>Step 2. Do this</C.Eres_headerxl>
            <p className="tw-break-words">Nunc luctus, sem sit amet vulputate luctus, orci dolor ultrices est, vitae convallis magna ligula ac odio. Aliquam venenatis nisi dui, quis hendrerit neque finibus non. Maecenas in tincidunt mauris. Cras dolor lacus, fringilla quis tellus nec, condimentum rhoncus erat. Donec eget ultricies ante. In faucibus facilisis bibendum. Proin id elementum felis, et commodo nisl. Cras mauris diam, egestas vitae nunc non, facilisis accumsan purus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Nulla molestie tempor nunc at hendrerit.</p>
            <C.Eres_headerxl>Step 3. Do this</C.Eres_headerxl>
            <p className="tw-break-words">Morbi iaculis aliquam massa id aliquam. Aliquam dolor ipsum, volutpat id dolor eu, tristique ultricies felis. Donec id ante nibh. Nullam tristique mattis nisl, non venenatis lorem malesuada eu. Fusce aliquam sapien quis enim elementum, ut sagittis velit ullamcorper. Nam sagittis lacinia sagittis.</p>
        </div>
    )
}


export const Facebook_business_center_instruction = () => {
    return (
        <div className="tw-space-y-2 tw-max-w-full tw-overflow-x-auto">
            <C.Eres_headerlg>How To Create A Facebook Ad Account</C.Eres_headerlg>
            <p className="tw-break-words">Most people don't realize that when you sign up for Facebook, you're automatically creating an ad account also. Just go to Facebook's ads manager and you can note your Ad Account Identification number in the upper left.</p>
            <div className="tw-w-full tw-max-w-2xl">
                <YouTube videoId="o-ACY99hrhc" opts={{width: '100%'}} className="tw-mx-auto"/>
            </div>
            <C.Eres_headerxl>Step 1. Do this</C.Eres_headerxl>
            <p className="tw-break-words">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer tincidunt elementum molestie. Etiam ornare purus nec tincidunt vulputate. Duis sed faucibus quam. Interdum et malesuada fames ac ante ipsum primis in faucibus. In eleifend ipsum vitae bibendum maximus. Phasellus eleifend non leo nec ultricies. Donec venenatis in quam in fermentum. Vestibulum quam lacus, rhoncus vel sapien quis, dignissim eleifend dui. Donec faucibus ante erat, et tristique est faucibus eget.</p>
            <C.Eres_headerxl>Step 2. Do this</C.Eres_headerxl>
            <p className="tw-break-words">Nunc luctus, sem sit amet vulputate luctus, orci dolor ultrices est, vitae convallis magna ligula ac odio. Aliquam venenatis nisi dui, quis hendrerit neque finibus non. Maecenas in tincidunt mauris. Cras dolor lacus, fringilla quis tellus nec, condimentum rhoncus erat. Donec eget ultricies ante. In faucibus facilisis bibendum. Proin id elementum felis, et commodo nisl. Cras mauris diam, egestas vitae nunc non, facilisis accumsan purus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Nulla molestie tempor nunc at hendrerit.</p>
            <C.Eres_headerxl>Step 3. Do this</C.Eres_headerxl>
            <p className="tw-break-words">Morbi iaculis aliquam massa id aliquam. Aliquam dolor ipsum, volutpat id dolor eu, tristique ultricies felis. Donec id ante nibh. Nullam tristique mattis nisl, non venenatis lorem malesuada eu. Fusce aliquam sapien quis enim elementum, ut sagittis velit ullamcorper. Nam sagittis lacinia sagittis.</p>
        </div>
    )
}


const pixel_verification_parse = z.object({
    is_found: z.boolean(),
    found_id: z.string().nullish(),
})

type verification_t = z.infer<typeof pixel_verification_parse>

const send_api_verify_request = async (network: string, website_url: string, token: authn_token) => {
    const facebook_endpoint = v1api`social/facebook/verify-pixel-snippet?url=${website_url}`
    const linkedin_endpoint = v1api`social/linkedin/verify-insight-tag-snippet?url=${website_url}`
    const tiktok_endpoint = v1api`social/tiktok/verify-pixel-snippet?url=${website_url}`

    let endpoint = ""
    switch (network) {
        case "facebook":
            endpoint = facebook_endpoint
            break
        case "linkedin":
            endpoint = linkedin_endpoint
            break
        case "tiktok":
            endpoint = tiktok_endpoint
            break
        default:
            return
    }

    const verify_task = issue_json_get(endpoint, pixel_verification_parse, token)
    const response = await Promise.resolve(verify_task)
    const [rok, rresponse] = response

    if (!rok) {
        return
    }
    return rresponse
}

// @TODO: refactor Meta_pixel_instruction, Linkedin_insight_tag_instruction, Tiktok_pixel_instruction
export const Meta_pixel_instruction = () => {
    const [ state, dispatch ] = useWizardContext();
    const [ps, cs] = P.use_authenticated_program_state();
    const [website_url, set_website_url] = React.useState("");
    const [is_loading, set_is_loading] = React.useState(false);
    const [verification_result, set_verification_result] = React.useState<verification_t | null>(null)

    const on_input_change = (e: React.ChangeEvent<HTMLInputElement>) => {
        set_website_url(e.target.value);
        set_verification_result(null)
    }

    const verify_click = () => {
        set_is_loading(true)
        set_verification_result(null)
        dispatch({type: "SET_STEP_DATA", payload: {step_id: "step2", substep_id: "substep21", data: {website_url: website_url}}})
        const result = send_api_verify_request("facebook", website_url, cs.token)
        result.then((r) => {
            set_is_loading(false);
            set_verification_result(r || null)
            if (r && r.is_found) {
                dispatch({type: "MARK_STEP_COMPLETE", payload: {step_id: "step2", substep_id: "substep21"}})
            } else {
                dispatch({type: "MARK_STEP_INCOMPLETE", payload: {step_id: "step2", substep_id: "substep21"}})
            }
        })
    }

    const skip_click = () => {
        dispatch({type: "MARK_STEP_COMPLETE", payload: {step_id: "step2", substep_id: "substep21"}})
        dispatch({type: "NEXT_STEP"})
    }

    return (
        <C.Eres_card className="tw-overflow-x-auto">
            <div className="tw-m-2 md:tw-m-3 tw-h-min">
                <C.Eres_header2xl>Meta Pixel</C.Eres_header2xl>
                <C.Eres_hline className="tw-m-3" />
                <div className="tw-space-y-2 tw-my-2">
                    <C.Eres_headerlg>I. Verify Meta Pixel</C.Eres_headerlg>
                    <p>Please input the website that you have installed the pixel and we will verify if it is successfully installed or not.</p>
                    <div className="tw-w-full tw-flex tw-flex-col tw-gap-2">
                        <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-2 sm:tw-items-center">
                            <C.Eres_form_label htmlFor="website-url" className="sm:tw-w-32 tw-shrink-0">Website URL</C.Eres_form_label>
                            <C.Eres_line_edit id="website-url" aria-label="name" defaultValue="" type="text" onChange={on_input_change} className="tw-flex-1" />
                        </div>
                        <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-2">
                            <C.Eres_iconbutton id="f-cancel" icon={is_loading ? "eres-spinner" : faCheck} type="reset" onClick={verify_click} disabled={is_loading} >Verify</C.Eres_iconbutton>
                            <C.Eres_iconbutton onClick={skip_click}>Skip this step</C.Eres_iconbutton>
                        </div>
                    </div>
                    { (verification_result && verification_result.is_found) &&
                        <p className="tw-text-sm tw-font-semibold tw-text-big-stone-900 tw-text-green-800">Your pixel with id {verification_result.found_id} is currently installed.</p>
                    }
                    {   (verification_result && !verification_result.is_found) &&
                        <p className="tw-text-sm tw-font-semibold tw-text-big-stone-900 tw-text-red-800">We couldn't detect a Facebook Pixel on the specified URL. Please ensure it's installed correctly and try again. <br /><br />To learn more about the Facebook Pixel and how to install, read this <a href="https://eres.io/blog/how-to-create-configure-install-facebook-pixel/" target="_blank"><span className="tw-underline">article</span></a>.<br /><br /></p>
                    }
                </div>
                <C.Eres_collapse title="Install Pixel Instructions">
                    <div className="tw-space-y-2 tw-py-2">
                        <C.Eres_headerlg>II. How To Create And Install A Meta Pixel</C.Eres_headerlg>
                        <p>To learn more about the Meta Pixel and how to create and install, read this <a href="https://eres.io/blog/how-to-create-configure-install-facebook-pixel/" target="_blank"><span className="tw-underline">article</span></a>.</p>
                        <C.Eres_headerxl>Requirements</C.Eres_headerxl>
                        <p><ul><li className="tw-mb-1">1. You need a website.</li><li>2. You need to have access to the website files in order to add the pixel to your website's code.</li></ul></p>
                        <C.Eres_headerxl>Create a Meta Pixel</C.Eres_headerxl>
                        <p><ul><li className="tw-mb-1">1. Go to <a href="https://www.facebook.com/events_manager2"><span className="tw-underline">Meta's Event Manager</span></a>.</li><li className="tw-mb-1">2. Click the green circle with a white plus symbol that reads "Connect Data Sources" and choose "Web".<br /><br /><img src={create_pixel} style={{ height: '50vh' }} /></li><li className="tw-mb-1">3. Select Facebook Pixel, then Connect.</li><li className="tw-mb-1">4. Customize the name of your Pixel.</li><li>5. Input your website's domain, click Continue.</li></ul></p>
                        <C.Eres_headerxl>Installing a Meta Pixel</C.Eres_headerxl>
                        <p><ul><li className="tw-mb-1">1. Go to <a href="https://www.facebook.com/events_manager2"><span className="tw-underline">Meta's Event Manager</span></a>.</li><li className="tw-mb-1">2. Select the pixel that you named above, and click Connect.</li><li className="tw-mb-1">3. Select Install code manually.</li><li className="tw-mb-1">4. Copy the code snippet.</li><li className="tw-mb-1">5. Open the header or index.html file in your website and paste the code just above the <code className="bg-gray-100 p-2 font-mono text-sm">&lt;/head&gt;</code>, then save that file.</li><li>6. Click Continue in the Facebook pixel screen, optionally toggle on the Automatic Advanced Matching and verify the customer info you want to send and then click Continue, then Done.</li></ul></p>
                    </div>
                </C.Eres_collapse>
            </div>
        </C.Eres_card>
    )
}


export const Linkedin_insight_tag_instruction = () => {
    const [ state, dispatch ] = useWizardContext();
    const [ps, cs] = P.use_authenticated_program_state();
    const [website_url, set_website_url] = React.useState("");
    const [is_loading, set_is_loading] = React.useState(false);
    const [verification_result, set_verification_result] = React.useState<verification_t | null>(null)

    const on_input_change = (e: React.ChangeEvent<HTMLInputElement>) => {
        set_website_url(e.target.value);
        set_verification_result(null)
    }

    const verify_click = () => {
        set_is_loading(true)
        set_verification_result(null)
        const result = send_api_verify_request("linkedin", website_url, cs.token)
        result.then((r) => {
            set_is_loading(false);
            set_verification_result(r || null)
            if (r && r.is_found) {
                dispatch({type: "MARK_STEP_COMPLETE", payload: {step_id: "step2", substep_id: "substep22"}})
            } else {
                dispatch({type: "MARK_STEP_INCOMPLETE", payload: {step_id: "step2", substep_id: "substep22"}})
            }
        })
    }

    const skip_click = () => {
        dispatch({type: "MARK_STEP_COMPLETE", payload: {step_id: "step2", substep_id: "substep22"}})
        dispatch({type: "NEXT_STEP"})
    }

    const Insight_tag_string = 
        `<!-- LinkedIn Insight Tag Code -->
        <script type="text/javascript">
        _linkedin_partner_id = "your_partner_id";
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
        </script><script type="text/javascript">
        (function(l) {
        if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
        window.lintrk.q=[]}
        var s = document.getElementsByTagName("script")[0];
        var b = document.createElement("script");
        b.type = "text/javascript";b.async = true;
        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
        s.parentNode.insertBefore(b, s);})(window.lintrk);
        </script>
        <noscript>
        <img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=your_partner_id&fmt=gif" />
        </noscript>
        <!-- End LinkedIn Insight Tag Code -->`;

    const Conversion_string = `<script type="text/javascript">
    lintrk('track', { conversion_id: your_conversion_id });
    </script>`

    return (
        <C.Eres_card className="tw-overflow-x-auto">
            <div className="tw-m-2 md:tw-m-3 tw-h-min">
                <C.Eres_header2xl>LinkedIn Insight Tag</C.Eres_header2xl>
                <C.Eres_hline className="tw-m-3" />
                <div className="tw-space-y-2 tw-my-2">
                    <C.Eres_headerlg>I. Verify LinkedIn Insight Tag</C.Eres_headerlg>
                    <p>Please input the website that you have installed the Insight Tag and we will verify if it is successfully installed or not.</p>
                    <div className="tw-w-full tw-flex tw-flex-col tw-gap-2">
                        <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-2 sm:tw-items-center">
                            <C.Eres_form_label htmlFor="website-url" className="sm:tw-w-32 tw-shrink-0">Website URL</C.Eres_form_label>
                            <C.Eres_line_edit id="website-url" aria-label="name" defaultValue="" type="text" onChange={on_input_change} className="tw-flex-1" />
                        </div>
                        <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-2">
                            <C.Eres_iconbutton id="f-cancel" icon={is_loading ? "eres-spinner" : faCheck} type="reset" onClick={verify_click} disabled={is_loading}>Verify</C.Eres_iconbutton>
                            <C.Eres_iconbutton onClick={skip_click}>Skip this step</C.Eres_iconbutton>
                        </div>
                    </div>
                    { (verification_result && verification_result.is_found) && 
                        <p className="tw-text-sm tw-font-semibold tw-text-green-800">Your insight tag with id {verification_result.found_id} is currently installed.</p>
                    }
                    {   (verification_result && !verification_result.is_found) &&
                        <p className="tw-text-sm tw-font-semibold tw-text-red-800">We couldn't detect a LinkedIn Insight Tag on the specified URL. Please ensure it's installed correctly and try again. <br /><br />To learn more about the LinkedIn Insight Tag and how to install, read this <a href="https://eres.io/blog/embedding-linkedin-insight-tag-conversion-tracking-on-your-website/" target="_blank"><span className="tw-underline">article</span></a>.<br /><br /></p>
                    }
                </div>
                <C.Eres_collapse title="Install Pixel Instructions">
                    <div className="tw-space-y-2 tw-py-2">
                        <C.Eres_headerlg>II. How To Create And Install A LinkedIn Insight Tag</C.Eres_headerlg>
                        <p>For detailed guidance on creating and installing the LinkedIn Insight Tag on your Shopify or WordPress site, please refer to this <a href="https://eres.io/blog/embedding-linkedin-insight-tag-conversion-tracking-on-your-website/" target="_blank"><span className="tw-underline">article</span></a>.</p>
                        <C.Eres_headerxl>Requirements</C.Eres_headerxl>
                        <p><ul><li className="tw-mb-1">1. You need a website.</li><li>2. You need to have access to the website files in order to add the pixel to your website's code.</li></ul></p>
                        <C.Eres_headerxl>Create a LinkedIn Insight Tag</C.Eres_headerxl>
                        <p><img src={insight_tag} style={{ height: '50vh' }} /><br />
                        <ul>
                            <li className="tw-mb-1">1. Go to <a href="https://www.linkedin.com/campaignmanager/accounts"><span className="tw-underline">LinkedIn's Campaign Manager</span></a>.</li>
                            <li className="tw-mb-1">2. Select your account.<br /><br /></li>
                            <li className="tw-mb-1">3. Click on the "Analyze" dropdown and select "Insight Tag".</li>
                            <li>4. You'll see the option to "Install my Insight tag". Click it, and select "I will install the tag myself" to reveal the tag code that looks similar to the below example.</li>
                        </ul>
                        <br />
                        <C.Eres_code_snippet code={Insight_tag_string} />
                        <br />
                        </p>
                        <C.Eres_headerxl>Embed the Insight Tag</C.Eres_headerxl>
                        <p><ul>
                            <li className="tw-mb-1">1. Copy the LinkedIn Insight Tag script.</li>
                            <li className="tw-mb-1">2. Paste it just before the closing <code className="bg-gray-100 p-2 font-mono text-sm">&lt;/body&gt;</code> tag of your HTML.</li>
                            <li>3. Replace “your_partner_id” if you used our example and not copied directly from LinkedIn.</li>
                        </ul></p>
                        <C.Eres_headerxl>Setup Conversion Tracking</C.Eres_headerxl>
                        <p><ul>
                            <li className="tw-mb-1">1. After embedding the Insight Tag, identify the conversion actions on your site (e.g., form submissions, downloads, or page visits).</li>
                            <li>2. For each conversion action, add the following trigger snippet immediately after the Insight Tag code on the page where the conversion occurs (you must first create these conversions directly in LinkedIn's Campaign Manager to get the conversion_id):</li><br />
                            <C.Eres_code_snippet code={Conversion_string} />
                        </ul></p>
                    </div>
                </C.Eres_collapse>
            </div>
        </C.Eres_card>
    )
}


export const Tiktok_pixel_instruction = () => {
    const [ state, dispatch ] = useWizardContext();
    const [ps, cs] = P.use_authenticated_program_state();
    const [website_url, set_website_url] = React.useState("");
    const [is_loading, set_is_loading] = React.useState(false);
    const [verification_result, set_verification_result] = React.useState<verification_t | null>(null)

    const on_input_change = (e: React.ChangeEvent<HTMLInputElement>) => {
        set_website_url(e.target.value)
        set_verification_result(null)
    }

    const verify_click = () => {
        set_is_loading(true)
        set_verification_result(null)
        const result = send_api_verify_request("tiktok", website_url, cs.token)
        result.then((r) => {
            set_is_loading(false);
            set_verification_result(r || null)
            if (r && r.is_found) {
                dispatch({type: "MARK_STEP_COMPLETE", payload: {step_id: "step2", substep_id: "substep23"}})
            } else {
                dispatch({type: "MARK_STEP_INCOMPLETE", payload: {step_id: "step2", substep_id: "substep23"}})
            }
        })
    }

    const skip_click = () => {
        dispatch({type: "MARK_STEP_COMPLETE", payload: {step_id: "step2", substep_id: "substep23"}})
        dispatch({type: "NEXT_STEP"})
    }

    const TikTok_pixel_string =
        `<!-- TikTok Pixel Code -->
        <script>
            !function (w, d, t) {
              w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
            
              ttq.load('your_pixel_id');
              ttq.page();
            }(window, document, 'ttq');
        </script>
        <!-- End TikTok Code -->`;

    return (
        <C.Eres_card className="tw-overflow-x-auto">
            <div className="tw-m-2 md:tw-m-3 tw-h-min">
                <C.Eres_header2xl>Tiktok Pixel</C.Eres_header2xl>
                <C.Eres_hline className="tw-m-3" />
                <div className="tw-space-y-2 tw-my-2">
                    <C.Eres_headerlg>I. Verify Pixel</C.Eres_headerlg>
                    <p>Please input the website that you have installed the pixel and we will verify if it is successfully installed or not</p>
                    <div className="tw-w-full tw-flex tw-flex-col tw-gap-2">
                        <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-2 sm:tw-items-center">
                            <C.Eres_form_label htmlFor="website-url" className="sm:tw-w-32 tw-shrink-0">Website URL</C.Eres_form_label>
                            <C.Eres_line_edit id="website-url" aria-label="name" defaultValue="" type="text" onChange={on_input_change} className="tw-flex-1" />
                        </div>
                        <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-2">
                            <C.Eres_iconbutton id="f-cancel" icon={is_loading ? "eres-spinner" : faCheck} type="reset" onClick={verify_click} disabled={is_loading}>Verify</C.Eres_iconbutton>
                            <C.Eres_iconbutton onClick={skip_click}>Skip this step</C.Eres_iconbutton>
                        </div>
                    </div>
                    { (verification_result && verification_result.is_found) && 
                        <p className="tw-text-sm tw-font-semibold tw-text-green-800">Congrats, we found your pixel installed with id {verification_result.found_id}</p>
                    }
                    {   (verification_result && !verification_result.is_found) &&
                        <p className="tw-text-sm tw-font-semibold tw-text-red-800">We could not detect a pixel
                            installed on the given url, please install and try again. <br/><br/>To learn more about TikTok's pixel and how to install, read this <a href="https://eres.io/blog/a-guide-to-creating-and-installing-the-tiktok-pixel/" target="_blank"><span className="tw-underline">article</span></a>.<br/><br/></p>
                    }
                </div>
                <C.Eres_collapse title="Install Pixel Instructions">
                    <div className="tw-space-y-2">
                        <C.Eres_headerlg>II. How To Create And Install A TikTok Pixel</C.Eres_headerlg>
                        <p>For detailed guidance on creating and installing the TikTok Pixel on your Shopify or WordPress site, please refer to this <a href="https://eres.io/blog/a-guide-to-creating-and-installing-the-tiktok-pixel/" target="_blank"><span className="tw-underline">article</span></a>.</p>
                        <C.Eres_headerxl>Requirements</C.Eres_headerxl>
                        <p><ul><li className="tw-mb-1">1. You need a website.</li><li>2. You need to have access to the website files in order to add the pixel to your website's code.</li></ul></p>
                        <C.Eres_headerxl>Create a TikTok Pixel</C.Eres_headerxl>
                        <p>
                        <ul>
                            <li className="tw-mb-1">1. Go to <a href="https://ads.tiktok.com/"><span className="tw-underline">TikTok's Ad Manager</span></a>.</li>
                            <li className="tw-mb-1">2. Log in to your TikTok Ads Manager account and navigate to the "Assets" section. Select "Events" from the submenu.<br /><br /></li>
                            <li className="tw-mb-1">3. Under "Web Events," click "Manage" and then "Set Up Web Events." Choose "TikTok Pixel" as your connection method and click "Next." Give your Pixel a clear and descriptive name, and choose "Manually Install Pixel Code" for granular control.</li>
                            <li>4. Click "Copy Pixel Code" to save the provided JavaScript snippet for later use. Alternatively, you can download the code for manual reference.</li>
                        </ul>
                        <br />
                        <C.Eres_code_snippet code={TikTok_pixel_string} />
                        </p>
                        <C.Eres_headerxl>Installing the Pixel</C.Eres_headerxl>
                        <p><ul>
                            <li className="tw-mb-1">1. Copy the TikTok pixel script.</li>
                            <li className="tw-mb-1">2. Paste it just before the closing <code className="bg-gray-100 p-2 font-mono text-sm">&lt;/body&gt;</code> tag of your HTML.</li>
                            <li>3. Replace “your_pixel_id” if you used our example and not copied directly from TikTok.</li>
                            <li>4. Save your changes.</li>
                        </ul></p>
                    </div>
                </C.Eres_collapse>
            </div>
        </C.Eres_card>
    )
}
